import * as React from 'react';
import { SVGProps } from 'react';

const IconFunnelSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11 2H1v.586a1 1 0 0 0 .293.707l3.414 3.414A1 1 0 0 1 5 7.414V11l2-1V7.414a1 1 0 0 1 .293-.707l3.414-3.414A1 1 0 0 0 11 2.586V2z" />
  </svg>
);
export default IconFunnelSizeXs;
